import React from "react";
import { useGetVideosQuery } from "../../features/videos/videosApi";
import { sortArrayBasedOnId } from "../../utils/sortArrayBasedOnId";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import SingleVideo from "./SingleVideo";

export default function VideosList() {
  const { data: videos, isLoading, isError, error } = useGetVideosQuery();
  const sortedVideos = sortArrayBasedOnId(videos);

  // decide what to render in the ui
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && videos?.length === 0) {
    content = (
      <div style={{ textAlign: "center", fontSize: "18px" }}>
        No videos found! Click on the "add video" button to add new videos.
      </div>
    );
  } else if (!isLoading && !isError && videos?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Video Title</th>
            <th className="table-th">Description</th>
            <th className="table-th">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">
          {sortedVideos?.map((video, i) => (
            <SingleVideo key={video.id} index={i} video={video} />
          ))}
        </tbody>
      </table>
    );
  }
  return <>{content}</>;
}
